var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_c('n-button-regular',{staticClass:"mt-6",nativeOn:{"click":function($event){return _vm.accept.apply(null, arguments)}}},[_vm._v(" OK ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }